import React from "react";
import styled from "styled-components";
import PretendardText from "../text/pretendardText";

function ImgInputIcon({ id, accept, onChange }) {
  return (
    <>
      <FileInput type="file" id={id} accept={accept} onChange={onChange} />
      <FileLabel htmlFor={id}>
        <PretendardText
          style={{
            color: "#aaa",
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "22.75px",
            textAlign: "center",
          }}
        >
          아이콘 파일 업로드
        </PretendardText>
      </FileLabel>
    </>
  );
}

export default ImgInputIcon;

const FileInput = styled.input.attrs((props) => {})`
  position: absolute;
  width: 0;
  height: 0;
  padding: 0;
  overflow: hidden;
  border: 0;
`;

const FileLabel = styled.label.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  cursor: pointer;
`;
